var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _ReactionsState_instances, _ReactionsState_state, _ReactionsState_update;
import { getDefaultMessageReactionCounts, } from "./types";
export class ReactionsState {
    constructor() {
        _ReactionsState_instances.add(this);
        _ReactionsState_state.set(this, {});
        this.clear = () => {
            __classPrivateFieldSet(this, _ReactionsState_state, {}, "f");
        };
        this.add = ({ messageTimetoken, reactionKey, isOptimistic, isMe, reactionTimetoken, }) => {
            return __classPrivateFieldGet(this, _ReactionsState_instances, "m", _ReactionsState_update).call(this, messageTimetoken, reactionKey, ({ count, optimisticState }) => {
                if (isMe === false) {
                    return {
                        count: count + 1,
                    };
                }
                // If the reaction is from the same user account, check if we have
                // already added it optimistically, and don't increment in that case.
                const newCount = optimisticState === "added" ? count : count + 1;
                if (isOptimistic) {
                    return {
                        count: newCount,
                        optimisticState: "added",
                    };
                }
                return {
                    count: newCount,
                    optimisticState: undefined,
                    sentActionTimetoken: reactionTimetoken,
                };
            });
        };
        this.addBatch = (batch) => {
            batch.forEach(({ reactions, timetoken }) => {
                if (reactions) {
                    __classPrivateFieldGet(this, _ReactionsState_state, "f")[timetoken.toString()] = reactions;
                }
            });
        };
        this.remove = ({ messageTimetoken, reactionKey, isOptimistic, isMe, }) => {
            return __classPrivateFieldGet(this, _ReactionsState_instances, "m", _ReactionsState_update).call(this, messageTimetoken, reactionKey, ({ count, optimisticState }) => {
                if (isMe === false) {
                    return {
                        count: Math.max(count - 1, 0),
                    };
                }
                // If the reaction removal is from the same user account, check if we
                // have already removed optimistically. Don't decrement in that case.
                const newCount = optimisticState === "removed" ? count : Math.max(count - 1, 0);
                if (isOptimistic) {
                    return {
                        count: newCount,
                        optimisticState: "removed",
                    };
                }
                return {
                    count: newCount,
                    optimisticState: undefined,
                    sentActionTimetoken: undefined,
                };
            });
        };
        this.removeAll = (messageTimetoken) => {
            const _a = __classPrivateFieldGet(this, _ReactionsState_state, "f"), _b = messageTimetoken.toString(), reactionsForTimetoken = _a[_b], otherReactions = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            __classPrivateFieldSet(this, _ReactionsState_state, otherReactions, "f");
            return reactionsForTimetoken;
        };
        this.getReactionTimetoken = (messageTimetoken, reactionKey) => {
            var _a, _b;
            return (_b = (_a = __classPrivateFieldGet(this, _ReactionsState_state, "f")[messageTimetoken.toString()]) === null || _a === void 0 ? void 0 : _a[reactionKey]) === null || _b === void 0 ? void 0 : _b.sentActionTimetoken;
        };
    }
    get state() {
        return __classPrivateFieldGet(this, _ReactionsState_state, "f");
    }
}
_ReactionsState_state = new WeakMap(), _ReactionsState_instances = new WeakSet(), _ReactionsState_update = function _ReactionsState_update(messageTimetoken, reactionKey, getChange) {
    var _a;
    const timetokenKey = messageTimetoken.toString();
    const reactionsToThisMessage = (_a = __classPrivateFieldGet(this, _ReactionsState_state, "f")[timetokenKey]) !== null && _a !== void 0 ? _a : getDefaultMessageReactionCounts();
    const reactionsOfThisTypeForThisMessage = reactionsToThisMessage[reactionKey];
    const newReactionsOfThisTypeForThisMessage = Object.assign(Object.assign({}, reactionsOfThisTypeForThisMessage), getChange(reactionsOfThisTypeForThisMessage));
    __classPrivateFieldSet(this, _ReactionsState_state, Object.assign(Object.assign({}, __classPrivateFieldGet(this, _ReactionsState_state, "f")), { [timetokenKey]: Object.assign(Object.assign({}, reactionsToThisMessage), { [reactionKey]: newReactionsOfThisTypeForThisMessage }) }), "f");
    // Because of optimistic updates, this function will get called
    // twice. The first time it is called, the count will change. The
    // second time, it will not. The caller needs to know this, because
    // it may want to publish an event on change.
    return (newReactionsOfThisTypeForThisMessage.count -
        reactionsOfThisTypeForThisMessage.count);
};
